import request from "../_helpers/request";

export const openSearchService = {
  GetAllWordSplitData,
  EditWordSplitData,
};

/**
 * Retrieves all word split data from the search API.
 *
 * @param {Object} params - The parameters for the request.
 * @param {string} params.analyzerName - The name of the analyzer.
 * @param {string} params.word - The word to analyze.
 * @param {string} params.pageNum - The page number.
 * @param {string} params.pageSize - The number of results per page.
 * @return {Promise<Object>} A promise that resolves to the response data.
 */
async function GetAllWordSplitData(params) {
  const url = `${process.env.VUE_APP_WEBCOREAPI_SEARCH_BASE_PATH}GetAnalyzerList`;

  return await request.post(url, params).then(async (res) => {
    const data = res?.data ? JSON.parse(res.data) : null;
    res.data = data;

    return res;
  });
}

/**
 * Edits word split data by sending a POST request to the specified URL with the given parameters.
 *
 * @param {{cmd: "add" | "delete"; key: string; value: string}[]} SplitVocabEntries - The parameters for the request.
 * @return {Promise<Object>} A promise that resolves to the response data.
 */
async function EditWordSplitData(SplitVocabEntries) {
  const url = `${process.env.VUE_APP_WEBCOREAPI_SEARCH_BASE_PATH}PushSplitVocab`;

  SplitVocabEntries = SplitVocabEntries.filter(
    (entry) => entry.key.length <= 10 && entry.value.length <= 32
  );

  const params = { SplitVocabEntries };

  return await request.post(url, params).then((res) => {
    const data = res?.data ? JSON.parse(res.data) : null;
    res.data = data;

    return res;
  });
}
